import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Plus } from "lucide-react";
import { AppShell } from "../components/layout/AppShell";
import { NeuButton } from "../components/neu/Neu";
import { useCachedResource } from "../hooks/useCachedResource";
import { listBranches } from "../api/directory";
import { BranchForm } from "../features/admin/BranchForm";
import { BranchList } from "../features/admin/BranchList";
import { OrgScopeTabs } from "../features/admin/OrgScopeTabs";
import { CompanyProfile } from "../features/settings/CompanyProfile";
import { CompanyLeavePolicy } from "../features/settings/CompanyLeavePolicy";
import { CompanyAttendancePolicy } from "../features/settings/CompanyAttendancePolicy";
import { CompanyPayrollPolicy } from "../features/settings/CompanyPayrollPolicy";

export default function BranchesPage() {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const scope = params.get("tab") === "company" ? "company" : "branches";
  const setScope = (s) => setParams(s === "company" ? { tab: "company" } : {}, { replace: true });
  const [adding, setAdding] = useState(false);

  const { data, reload: load } = useCachedResource("branches", () => listBranches());
  const branches = data || [];

  return (
    <AppShell
      title={t("org.title")}
      subtitle={t("org.subtitle")}
      actions={
        scope === "branches" ? (
          <NeuButton
            variant="primary"
            data-testid="branch-add-btn"
            className="flex items-center gap-2"
            onClick={() => setAdding(true)}
          >
            <Plus className="h-4 w-4" /> {t("branches.add")}
          </NeuButton>
        ) : null
      }
    >
      <div className="detail-zoom grid gap-6">
        <OrgScopeTabs scope={scope} onChange={setScope} />

        {scope === "company" ? (
          <>
            <CompanyProfile />
            <CompanyPayrollPolicy />
            <CompanyLeavePolicy />
            <CompanyAttendancePolicy />
          </>
        ) : (
          <>
            {adding ? (
              <BranchForm
                initial={null}
                initialTab="basics"
                onCancel={() => setAdding(false)}
                onSaved={() => {
                  setAdding(false);
                  load();
                }}
              />
            ) : null}
            <BranchList branches={branches} />
          </>
        )}
      </div>
    </AppShell>
  );
}
